export const SET_SLACK_USERS = 'SET_SLACK_USERS'
